import pgRate from './pgRate.vue'
export default pgRate
